
import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams,Platform } from 'ionic-angular';
import JsBarcode from 'jsbarcode';
import { Storage } from '@ionic/storage'
import { CajaProvider } from '../../providers/caja/caja'
import { Printer, PrintOptions } from '@ionic-native/printer';

@IonicPage()
@Component({
  selector: 'page-imprimir',
  templateUrl: 'imprimir.html',
  providers: [Printer]
})
export class ImprimirPage {
  @ViewChild('canvasOld') canvasElement : ElementRef;
  valores = []
  botonNoMostrar:boolean=true
  reciboCaja:string=""
  imagen:string=''
  canvasVer:boolean=false
  imagenEntidad:string="assets/imgs/icon.png"
  mostrarImagen:boolean=false
  codigo:any
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public storage:Storage,
             public servicio: CajaProvider,
             private printer: Printer,public platform:Platform) {


              this.valores = this.navParams.get('item')
              this.imagen = this.navParams.get('imagen')
              this.codigo = this.navParams.get('codigo')
              this.imagenEntidad = this.imagen
              this.mostrarImagen = this.imagen.length>5 ? true : false
                  setTimeout(()=>{
                    if (this.platform.is('android')) {
                      this.imprimirAndroid(this.valores)
                    }else{
                      this.imprimirDataPrint()
                    }

                  },1000)
}

imprimirAndroid(recibo:any){
  this.printer.isAvailable().then();

  let options: PrintOptions = {
       name: 'MyDocument',
       printerId: 'printer007',
       duplex: true,
       landscape: true,
       grayscale: true
     };

  this.printer.print(recibo, options).then();
}

ionViewDidLoad() {
// this.imprimirData()
// setTimeout(()=>{
// this.imprimirDataPrint()
// },1000)
}

imprimirDataPrint(){
if(window){
this.botonNoMostrar = false
if(this.mostrarImagen){
this.canvasElementcodigo(this.codigo)
}
window.print();
this.navCtrl.pop();
} else {
alert("window is not defined");
}
}

  imprimir(){
    // let noimp = document.querySelector('botonNoMostrar')
    // noimp.className="botonNoMostrar"
    this.botonNoMostrar = false
    // this.canvasElementcodigo('andresnaranjo@afnarqui.com')
      if(window){
       window.print();
       this.navCtrl.pop();
      } else {
          console.warn("window is not defined");
      }
  }

  canvasElementcodigo(codigo){
    this.canvasElement.nativeElement.style ="display:block"
    JsBarcode(this.canvasElement.nativeElement, codigo, {

     text:codigo,
     margin: 0,
     marginLeft: 0,
     width: 4,
     height: 32,
     displayValue: true
   });
 }

ngAfterViewInit() {
  // this.canvasNoDefinido()
}
canvasNoDefinido(){
  // this.canvasElement.nativeElement.style ="display:block"

  // JsBarcode(this.canvasElement.nativeElement, "No definido", {
  //     fontSize: 20,
  //     background: "#AF7AC5",
  //     lineColor: "#990000",
  //     margin: 20,
  //     marginLeft: 20
  //   });
}

}



// WEBPACK FOOTER //
// ./src/pages/imprimir/imprimir.ts